<template>
    <div class="content_wrapper">

        <previewImagePopup :settings="previewImagePopupSettings"></previewImagePopup>
        <div class="service_info">
            <div class="no_data_wrapper" v-if="showEmptyDataView">
                <span>{{translate('noServiceLogs')}}</span>
            </div>
            <div class="service_logs_title_wrapper" v-if="customerName">
                <span>{{customerName}}</span>
            </div>
            <div class="frequency_service_wrapper" v-if="cleaningSchedule">
                <span>Frequency of service requested:<br>{{ cleaningSchedule }} <span>time(s)</span> per week</span>
            </div>
            <div class="service_logs_title_wrapper" v-if="logs && logs.length > 0">
                <span>Last <span v-if="logs.length >= 10">10</span> services:</span>
            </div>
            <div class="service_info_content__wrapper" v-for="(rate, index) in logs"
                 :key="index">
                <div class="content_titles">
                    <div class="content_titles__wrapper">
                        <div class="local_date">
                            {{ rate.local_date }}
                        </div>
                    </div>
                    <div class="content_titles__wrapper">
                        <div class="serviceLog" v-if="rate.sec_level.length > 0">
                            <div v-for="(item, index) in rate.sec_level" :key="index">{{ item }}</div>
                        </div>
                    </div>
                    <div class="content_titles__wrapper" v-if="rate.additional_data">
                        <div class="additional_data">{{ rate.additional_data }}</div>
                    </div>
                    <div class="content_titles__wrapper" v-if="rate.author">
                        <div class="author_name">By {{ rate.author }}</div>
                    </div>
                    <div class="content_titles__wrapper">
                        <div class="photo" v-if="rate.attachments.images.length !== 0">
                            <div class="preview">
                                <img v-for="(image, index) in rate.attachments.images"
                                     :key="index"
                                     :src="image.previewUrl"
                                     @click="onVoteImageClick(image)"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="content_titles__wrapper">
                        <div class="audio">
                            <audio controls='controls' v-if="rate.attachments.audio !== null">
                                <source :src="audioLink">
                            </audio>
                        </div>
                    </div>
                </div>
            </div>

            <div class="export-data-popup-wrapper" v-if="fogReport.showPopup" @mousedown="onExportPopupBackClick">
                <div class="export-data-popup" @click.stop="onExportPopupClick" @mousedown.stop="onExportPopupClick">
                    <input placeholder="Email" class="email-input"
                           v-model="fogReport.email">
                    <div class="send-btn" @click="requestFOGReport"><span>Send</span></div>
                </div>
            </div>

            <div class="export-btn-wrapper" v-if="fogReport.showBtn">
                <div class="export-btn" @click="onExportPdfClick">Email full service report</div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import previewImagePopup from "@/components/widgets/previewImagePopup";
import errorMixin from "@/mixins/errorMixin";

export default {
    name: "serviceLogHistory",
    mixins: [mixin, errorMixin],
    components: {
        previewImagePopup
    },
    data() {
        return {
            previewImagePopupSettings: null,
            showEmptyDataView: false,
            logs: [],
            cleaningSchedule: null,
            customerName: null,
            fogReport: {
                showPopup: false,
                showBtn: true,
                email: '',
            },
        }
    },
    async mounted() {
        let question_id = this.$route.params.questionId
        try {
            this.setProgressBarTag({
                show: true,
                tag: 'serviceLogInfo'
            })
            let response = await this.getServiceLogInfo({
                questionGuid: question_id,
                rate_uid: null,
            })
            if (response) {
                this.logs = []
                this.cleaningSchedule = response.data.cleaning_schedule
                this.customerName = response.data.customer_name
                this.logs = response.data.ratesData
                this.fogReport.showBtn = this.logs.length > 0 && response.data.show_fog_report_btn
                if(this.logs.length == 0) {
                    this.showEmptyDataView = true
                }
            }
        } catch (e) {
            this.showErrorModal(e.data.error.message)
        } finally {
            this.setProgressBarTag({
                show: false,
                tag: 'serviceLogInfo'
            })
        }
    },
    methods: {
        ...mapActions({
            getServiceLogInfo: 'rate/getServiceLogInfo',
            getPDFFogRequest: 'rate/getPDFFogRequest',
        }),
        ...mapMutations({
            setProgressBarTag: 'setProgressBarTag',
            setMessageModel: 'setMessageModel',
        }),
        onVoteImageClick(image) {
            this.previewImagePopupSettings = {
                image: image.originUrl
            }
        },

        onExportPdfClick() {
            this.fogReport.showPopup = true
        },

        onExportPopupBackClick() {
            this.fogReport.showPopup = false
        },
        onExportPopupClick() {

        },

        async requestFOGReport() {
            let question_id = this.$route.params.questionId
            if(this.fogReport.email == '') return
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'sendFOGPDFReportRequest'
                })
                let response = await this.getPDFFogRequest({
                    questionGuid: question_id,
                    email: this.fogReport.email,
                })
                if (response) {
                    this.fogReport.showPopup = false
                    let email = this.fogReport.email
                    this.fogReport.email = ''
                    this.setMessageModel({
                        msg: `PDF report was sent to ${email}`,
                        duration: 2000,
                    })
                }
            } catch (e) {
                this.showErrorModal(e.data.error.message)
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'sendFOGPDFReportRequest'
                })
            }
        },

    }

}
</script>

<style scoped>

.no_data_wrapper {
    text-align: center;
    margin-top: 48px;
    font-size: 18px;
}

.frequency_service_wrapper {
    text-align: start;
    font-size: 16px;
    margin-bottom: 16px;
    color: #404040;
}
.service_logs_title_wrapper {
    text-align: center;
    font-size: 18px;
    margin-bottom: 8px;
}

.service_info_title__wrapper {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.service_info_content__wrapper {
    display: flex;
    border-bottom: solid 1px rgb(0, 0, 0, .3);
    padding-top: 10px;
    padding-bottom: 10px;
}

.service_info {
    overflow: auto;
    padding: 16px;
    padding-bottom: 60px;
}

.date_content, .info_content {
    padding-bottom: 10px;
    padding-top: 10px;
}

.date_title, .info_title {
    font-size: 20px;
}

.content_titles__wrapper {
    display: flex;
}

.additional_data {
    font-weight: 600 !important;
    white-space: pre-wrap;
    line-height: 19px;
    margin-top: 4px;
}

.author_name {
    font-weight: 600 !important;
    white-space: pre-wrap;
    line-height: 19px;
    margin-top: 4px;
    font-size: 16px;
}

.content_titles__data, .content_titles__services, .content_titles__photo, .content_titles__audio {
    width: 80px;
}

.content_titles {
    display: flex;
    flex-direction: column;
}

.serviceLog {
    display: flex;
    flex-direction: column;
}

.serviceLog div {
    margin-right: 10px;
}

.preview {
    cursor: pointer;
}

.photo {
    display: flex;
    align-items: center;
}

.content_titles__photo {
    max-width: 100%;
    max-height: 60px;
    padding-right: 5px;
    height: 60px;
}

.content_titles__services {
    height: 40px;
}

.export-btn-wrapper {
    background: white;
    left: 0;
    position: fixed;
    right: 0;
    bottom: 0;
    height: 64px;
}
.export-btn {
    position: fixed;
    bottom: 12px;
    left: 12px;
    right: 12px;
    display: flex;
    justify-content: center;
    height: 40px;
    align-items: center;
    color: white;
    border-radius: 6px;
    background: #3F405C;
    cursor: pointer;
}

.export-data-popup-wrapper {
    position: fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    background: rgba(0, 0, 0, 0.47);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
}
.export-data-popup {
    border-radius: 4px;
    background: #ffffff;
    width: 80%;
    max-width: 250px;
    padding: 12px;
    display: flex;
    flex-direction: column;
}

.export-data-popup .send-btn {
    margin-top: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    color: #454545;
    cursor: pointer;
}

.export-data-popup .email-input {
    border: 1px solid #b4b4b4;
    border-radius: 2px;
    height: 30px;
    font-size: 15px;
    padding-left: 6px;
    padding-right: 6px;
}

</style>
